import { app } from '@/bootloader';
import moment from 'moment';

function gigabiteize(value, selectedSizeType) {
  if (selectedSizeType === 'MB') return value;
  if (selectedSizeType === 'GB') return parseFloat(Number(Number(value) / 1024).toFixed(2));
  if (selectedSizeType === 'TB') return parseFloat(Number(Number(value) / 1024 / 1024).toFixed(2));
  return value.replace(/\D/g, ''); // unknown convertor
}

function timitize(value, selectedTimeType) {
  if (selectedTimeType === 'SEC') return value;
  if (selectedTimeType === 'MIN') return Number((Number(value) / 60).toFixed(2));
  if (selectedTimeType === 'HRS') return Number((Number(value) / 3600).toFixed(2));
  return value.replace(/\D/g, ''); // unknown convertor
}

function timePeriod(value, selectedTimeType) {
  switch (selectedTimeType) {
    case 'MON':
      return parseFloat((+value / 30).toFixed(2));
    case 'DAYS':
    default:
      return value;
  }
}

export const formatDateUnix = (value, formatType = 'full', divideMiliseconds = true) => {
  if (value && !Number.isNaN(value)) {
    const timeVal = divideMiliseconds ? value / 1000 : value;
    switch (formatType) {
      case 'full':
        return moment.unix(+new Date(timeVal)).format('D/M/YYYY H:m:s');
      default:
        return null;
    }
  }
  return value;
};

export function inputWithMenuFilter(value, menuType, selectedOption) {
  if (!value || !selectedOption) return null;
  switch (menuType) {
    case 'disksize':
      return gigabiteize(value, selectedOption);
    case 'timeForm':
      return timitize(value, selectedOption);
    case 'timePeriod':
      return timePeriod(value, selectedOption);
    default:
      return value;
  }
}

const secondsToHHMMSS = value => {
  // value represents total seconds (at least that's my current assumption)
  const theSeconds = Number(value) % 60; // not showing seconds
  const totalMinutes = Math.floor(Number(value) / 60);
  const singleMinutes = totalMinutes % 60;
  const totalHours = Math.floor(totalMinutes / 60);
  // const singleHours = totalHours % 24;
  return `${totalHours ? `${totalHours}H ` : ''}${singleMinutes ? `${singleMinutes}M` : ''}${theSeconds ? `${theSeconds}S ` : ''}` || '0';
};
app.config.globalProperties.$filters = {
  formatDateUnix,
  inputWithMenuFilter,
  secondsToHHMMSS,
};
